/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import cn from 'clsx';
import { ATooltip } from 'components/Antd';
import { ReactComponent as AIInsightSvg } from 'assets/icons/New/ai-insight-1.svg';
import { apiProductAIInsight, apiProductBulkCreateRequirement } from 'api/ai';
import { callAction } from 'hooks/useData';
import AIModal from '../AIModal';
import { getAIData, AI_DATA_ARR, AI_DATA } from '../AIModal/data';
import classes from './AIInsight.module.scss';
import { generateSimplePDF } from 'modules/shared/PDF/index';
import { getDateWithFormat } from 'util/date';

let timeoutRef = null;

export const BetaTag = ({ style }) => {
  return (
    <span className={classes.betaTag} style={style}>
      beta
    </span>
  );
};

const AIInsight = ({ className, onExecuteAI, productDetail, productId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [checks, setChecks] = useState({});
  const useStaticData = false;

  return (
    <>
      <div></div>
      <div className={cn(classes.wrapper, className)}>
        <ATooltip
          dark
          title="Click to Generate AI Insight"
          placement="top"
          overlayClassName={classes.tooltipOverlay}>
          <span
            className={classes.btn}
            onClick={() => {
              setChecks({});
              setIsOpen(true);
            }}>
            <AIInsightSvg width={24} height={24} />
            <span>AI Insight</span>
            <BetaTag />
          </span>
        </ATooltip>
      </div>
      {!!isOpen && (
        <AIModal
          open
          onClose={() => {
            setIsOpen(false);
          }}
          productDetail={productDetail}
          onSubmit={async (values, loadingCb, cb) => {
            if (useStaticData) {
              loadingCb();
              cb(AI_DATA);
              const newChecks = {};
              getAIData(AI_DATA).forEach((section) => {
                (section.items || []).forEach((tItem) => {
                  if (tItem.fieldName) {
                    newChecks[tItem.fieldName] = true;
                  }
                });
              });
              setChecks(newChecks);
            } else {
              const res = await callAction(() =>
                apiProductAIInsight({
                  productDescription: values.product_description,
                  productName: values.product_name,
                  intendedUsed: values.product_intend,
                  exportMarket: values.import_country,
                })
              );
              if (loadingCb) loadingCb();
              if (res?.success) {
                const tAIData = res?.data?.data;
                const parseAIData = getAIData(tAIData);
                const newChecks = {};
                parseAIData.forEach((section) => {
                  (section.items || []).forEach((tItem) => {
                    if (tItem.fieldName) {
                      newChecks[tItem.fieldName] = true;
                    }
                  });
                });
                setChecks(newChecks);
                if (cb) cb(tAIData);
              }
            }
          }}
          onExecute={async (cb) => {
            const requirements = Object.keys(checks)
              .filter((key) => !!checks[key])
              .map((key) => {
                const keyArr = key.split('___');
                return {
                  customType: keyArr[0],
                  customName: keyArr[1],
                  isMandatory: true,
                };
              });
            await callAction(() =>
              apiProductBulkCreateRequirement(productId, {
                requirements,
              })
            );
            if (cb) cb();
            setIsOpen(false);
            onExecuteAI(checks);
          }}
          onCancelSubmit={() => {
            if (window && window.stop) {
              window.stop();
            }
            if (timeoutRef) {
              clearTimeout(timeoutRef);
              timeoutRef = null;
            }
          }}
          onChecksChange={(newChecks) => {
            setChecks((prev) => ({
              ...prev,
              ...newChecks,
            }));
          }}
          onDownload={(cb) => {
            setTimeout(() => {
              generateSimplePDF(
                'ai-pdf-export',
                {
                  margin: [5, 5, 5, 5],
                  filename: `ai_compliance_scan_${getDateWithFormat(new Date(), 'YYYY_MM_DD')}.pdf`,
                  pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                  jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                },
                cb
              );
            }, 100);
          }}
        />
      )}
    </>
  );
};

export default AIInsight;
